import React, { useState } from "react";
import ik2Image from "../assets/ik2.jpeg";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email) {
      alert("Please enter your email address");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      alert("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setIsSubscribed(true);
      setEmail("");
      
      setTimeout(() => {
        setIsSubscribed(false);
      }, 5001);
      
    } catch (error) {
      alert("Subscription failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="bg-eco-dark border-t border-white border-opacity-10 py-12">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-lg overflow-hidden border border-white/50">
                <img 
                  src={ik2Image} 
                  alt="X EcoChain" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <span className="text-lg font-black gradient-text">ECOCHAIN</span>
                <div className="eco-badge text-xs">White Mode</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Clean code. Clear conscience. Sustainable blockchain for the future.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Ecosystem</h4>
            <ul className="space-y-2">
              <li><a href="/ecosystem/green-staking" className="text-gray-400 hover:text-white transition-colors">Staking</a></li>
              <li><a href="/ecosystem/governance" className="text-gray-400 hover:text-white transition-colors">Governance</a></li>
              <li><a href="/developers" className="text-gray-400 hover:text-white transition-colors">Developers</a></li>
              <li><a href="/documentation" className="text-gray-400 hover:text-white transition-colors">Partners</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><a href="/documentation" className="text-gray-400 hover:text-white transition-colors">Documentation</a></li>
              <li><a href="https://github.com/xecochain/whitepaper" className="text-gray-400 hover:text-white transition-colors">Whitepaper</a></li>
              <li><a href="https://blog.xecochain.com" className="text-gray-400 hover:text-white transition-colors">Blog</a></li>
              <li><a href="mailto:support@xecochain.com" className="text-gray-400 hover:text-white transition-colors">Support</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Stay Updated</h4>
            {isSubscribed ? (
              <div className="bg-white/20 border border-white/50 rounded-lg p-4 text-center">
                <div className="text-white font-bold mb-2">🎉 Successfully Subscribed!</div>
                <p className="text-gray-300 text-sm">
                  Thank you for joining our community. We'll keep you updated!
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="space-y-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email = updates, not spam."
                  className="w-full px-4 py-3 bg-eco-black border border-gray-600 rounded-lg focus:outline-none focus:border-white text-white placeholder-gray-500"
                  required
                  disabled={isLoading}
                />
                <button 
                  type="submit"
                  className="w-full py-3 bg-white text-gray-900 font-bold rounded-lg hover:bg-gray-200 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isLoading}
                >
                  {isLoading ? "Subscribing..." : "Subscribe"}
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-white border-opacity-10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            ©️ 2025 X1 EcoChain. Clean code. Clear conscience.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a 
              href="https://t.me/+PgbVUDnoNWAxNjEx" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors flex items-center"
            >
              <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.181c-.174-.761-1.003-1.188-1.815-.972l-10.5 3.333c-.736.234-1.097 1.071-.803 1.781.213.51.714.833 1.26.833.143 0 .288-.025.428-.076l2.666-.849v.849c0 .736.597 1.333 1.333 1.333h.667v2.237c0 .736.597 1.333 1.333 1.333s1.333-.597 1.333-1.333v-2.237h.667c.736 0 1.333-.597 1.333-1.333V9.333l2.667.849c.736.234 1.573-.128 1.807-.864.068-.272.068-.552 0-.824l-1.333-5.333zm-1.333 4.152l-8-2.545 8-2.545v5.09z"/>
              </svg>
              Telegram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;